import API from '../../clients/api'

const fetchCategories = async () => {
  const route = `categories?root&number=6`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchCategory = async id => {
  const route = `categories/${id}`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchCategoryNewCourses = async id => {
  const route = `categories/${id}?metric=new-overall&number=4&embed=courses.presenter,courses.difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchCategoryPopularCourses = async id => {
  const route = `categories/${id}?metric=popular-overall&number=4&embed=courses.presenter,courses.difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchCategoryLearningPaths = async id => {
  const route = `categories/${id}?embed=playlists,playlists.difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data.playlists.data))
    .catch(error => Promise.reject(error.response.data))
}

export {
  fetchCategories,
  fetchCategory,
  fetchCategoryNewCourses,
  fetchCategoryPopularCourses,
  fetchCategoryLearningPaths,
}
